/**
 * @generated SignedSource<<406ccbe6d39adf5671126ef79a6916d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type pullRequestReview_periscope_PullRequestReviewTask$data = {
  readonly __typename: "WorkSuggestionsPullRequestReviewTask";
  readonly approvalsCount: number;
  readonly commentCount: number;
  readonly destinationBranchName: string | null | undefined;
  readonly id: string;
  readonly providerIconUrl: string | null | undefined;
  readonly providerName: string | null | undefined;
  readonly repositoryName: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "pullRequestReview_periscope_PullRequestReviewTask";
};
export type pullRequestReview_periscope_PullRequestReviewTask$key = {
  readonly " $data"?: pullRequestReview_periscope_PullRequestReviewTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"pullRequestReview_periscope_PullRequestReviewTask">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "pullRequestReview_periscope_PullRequestReviewTask",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "destinationBranchName"
    },
    {
      "kind": "ScalarField",
      "name": "providerName"
    },
    {
      "kind": "ScalarField",
      "name": "providerIconUrl"
    },
    {
      "kind": "ScalarField",
      "name": "approvalsCount"
    },
    {
      "kind": "ScalarField",
      "name": "commentCount"
    },
    {
      "kind": "ScalarField",
      "name": "repositoryName"
    }
  ],
  "type": "WorkSuggestionsPullRequestReviewTask"
};

(node as any).hash = "9929e638c179a4deaaf4a7bdef69fb53";

export default node;
